import React from "react";
import PropTypes from "prop-types";
// import { connect } from 'react-redux'
import { Nav, Navbar, NavItem, NavDropdown, MenuItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

export class FooterLinks extends React.Component {
  componentDidMount() {}

  componentWillReceiveProps(nextProps) {}

  getNavIndex(i, j) {
    return `${i}.${j}`;
  }

  renderSubMenus(menus, i) {
    return menus.map((lnk, j) => {
      let lnkTo = lnk.menu_url.toLowerCase();
      if (
        (lnk.internal_page_id === 0 && lnk.template_id === 5) ||
        lnkTo.indexOf("http") !== -1
      ) {
        return (
          <li key={j} role="presentation">
            <a
              key={this.getNavIndex(i, j)}
              role="menuitem"
              title=""
              href={lnk.menu_url}
              target="_blank"
            >
              {lnk.title}
            </a>
          </li>
        );
      } else {
        return (
          <LinkContainer key={j} to={{ pathname: "/" + lnk.menu_url }}>
            <MenuItem title="" key={j} eventKey={this.getNavIndex(i, j)}>
              {lnk.title}
            </MenuItem>
          </LinkContainer>
        );
      }
    });
  }

  renderMenu() {
    const { bottom_menus } = this.props;

    return bottom_menus.map((lnk, i) => {
      if (lnk.childs.length) {
        return (
          <NavDropdown
            key={i}
            eventKey={i}
            title={lnk.title}
            id="basic-nav-dropdown"
          >
            {this.renderSubMenus(lnk.childs, i)}
          </NavDropdown>
        );
      } else {
        let lnkTo = lnk.menu_url.toLowerCase();
        if (lnkTo.indexOf("http") !== -1) {
          return (
            <li key={`li${i}`} role="presentation">
              <a
                key={i}
                role="menuitem"
                title=""
                href={lnk.menu_url}
                target="_blank"
              >
                {lnk.title}
              </a>
            </li>
          );
        } else {
          return (
            <LinkContainer key={i} to={{ pathname: "/" + lnk.menu_url }}>
              <NavItem title="" key={i} eventKey={i}>
                {lnk.title}
              </NavItem>
            </LinkContainer>
          );
        }
      }
    });
  }

  render() {
    return (
      <div id="footer-links" className="row">
        <div className="col-md-12">
          <Navbar>
            <Navbar.Header>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              <Nav>{this.renderMenu()}</Nav>
            </Navbar.Collapse>
          </Navbar>
        </div>
      </div>
    );
  }
}

FooterLinks.propTypes = {
  bottom_menus: PropTypes.array.isRequired
};



// WEBPACK FOOTER //
// ./src/views/FooterLinks/FooterLinks.js